module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0008-01.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('a', {
    attrs: {
      "id": "introduction"
    }
  }), _c('strong', [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/contents"
    }
  }, [_vm._v("Introduction: How to Use This Book")])])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v("American cooks have rediscovered the joy of good ingredients, simply prepared. We’re clamoring for heirloom tomatoes, free-range chicken, and locally grown fingerlings. These days, it’s all about the ingredients. And that’s the focus of this book. We explain the inner workings of more than 290 common and uncommon ingredients and the best ways to grill them. We’ve combined America’s oldest cooking occasion—grilling outdoors—with its newest cooking obsession: preserving the integrity of high-quality ingredients.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The ins and outs of buying, preparing, and flavoring your favorite ingredients are explained throughout every chapter. To simplify these details, we created at-a-glance charts, which are master guides to everything you would ever want to grill. The charts show the ingredient’s different cuts or varieties, alternate names in the marketplace, best grilling methods, and substitutions.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Each chapter opens with a discussion of everything you need to know when buying, handling, and grilling the ingredient you’re working with, including straight talk about terms such as wild, farm-raised, ranched, pastured, grass-fed, grain-fed, milk-fed, formula-fed, free-range, water-chilled, air-chilled, natural, organic, and sustainable.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A few other things you’ll notice are little tidbits scattered throughout the recipes called “Know-How” and “Keep It Simple.” Know-How gives you must-have information like how to butterfly flank steak, or clean an octopus, and it includes step-by-step illustrations when necessary. Keep It Simple shows you alternate ways of preparing recipes in less time, using fewer ingredients. We know that some cooks want to be grill masters and some just want dinner on the table. Tips throughout the book can help you accomplish both.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("As devoted farmers’-market and gourmet-market shoppers, we put a premium on high-quality ingredients. We also know that some ingredients, like beef cheeks, can be hard to find. We offer tips throughout the recipes on sourcing oddball ingredients. You can also refer to the list of ingredient sources on page 400.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("We hope this book shows you a different way of looking at grilled food. Although the ingredient is the star, and not the grill, we don’t leave grilling novices hanging out to dry. "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01"
    }
  }, [_vm._v("Chapter 1")]), _vm._v(": A Primer on Grilling Methods & Equipment, explains everything you need to know to grill successfully. And "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02"
    }
  }, [_vm._v("Chapter 2")]), _vm._v(": How to Build Flavor into Anything Grilled, discusses all manner of marinades, brines, mops, rubs, pastes, and sauces, with 161 mini-recipes and variations, which you can use in the book’s recipes or in your own creations. The goal in all this is to help you grill every food imaginable, and do it successfully. Grilling can be about so much more than hot dogs and hamburgers. Here’s wishing you newfound joy at the grill and the deepest pleasure possible from every dish you share at your table.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f804d6e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/introduction.vue
// module id = 72
// module chunks = 0